module.exports = __webpack_public_path__ + "img/arrow-right-sky.3a76212f.svg";